/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { generateClient as commonGenerateClient, IBackendError, KargoApolloClient } from '@kargotech/tms-common/Services/apollo';
import { COMPANY_KSUID_STORAGE_KEY } from '@kargotech/tms-core/auth/constants';
import { Toast } from '@kargotech/tms-ui/components';
import { get } from 'lodash-es';

import Auth from '~/configurations/auth';
import {
  APP_CONTEXT,
  SERVICES_URL,
} from '~/configurations/constants';
import i18next from './i18n';

interface IClientHeader {
  [key: string]: string;
}

type BackendError = IBackendError & { extensions: Record<string, unknown> };

export const generateClient = (uri: string, skipAuth: boolean) => {
  async function setBearerToken(headers: IClientHeader) {
    // get the authentication token from local storage if it exists
    const cognitoCurrentSession = await Auth.currentSession();
    const token = cognitoCurrentSession.getIdToken().getJwtToken();

    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  }

  const appRoleSetter = () => APP_CONTEXT.toLowerCase();
  const companyKsuidSetter = () => localStorage.getItem(COMPANY_KSUID_STORAGE_KEY);

  return commonGenerateClient({
    uri,
    skipAuth,
    bearerTokenSetter: setBearerToken,
    appRoleSetter,
    companyKsuidSetter,
    onBackendError: (error: BackendError, operation) => {
      if (get(operation, 'variables.SKIP_TOAST')) {
        return;
      }
      const GENERAL_ERROR_CODE = [500, 401];
      if (
        (error.status_code && GENERAL_ERROR_CODE.includes(error.status_code))
        || (error.error_code && GENERAL_ERROR_CODE.includes(error.error_code))
      ) {
        Toast.error(
          i18next.t(
            `message:errors.backend.common.${
              error.status_code || error.error_code
            }`,
          ),
        );
      } else if (
        (error.status_code || error.error_code)
        && (error.path || []).length > 0
      ) {
        Toast.error(
          i18next.t(
            `message:errors.backend.${error.path[0]}.${
              error.status_code || error.error_code
            }`,
          ),
        );
      } else {
        const errorMessage = error?.message ?? i18next.t('message:errors.unexpected');
        if (error?.message === 'RateLimiter') {
          Toast.error(error?.extensions?.desc);
        } else {
          Toast.error(errorMessage);
        }
      }
    },
    onNetworkError: (networkError) => {
      if (networkError.statusCode === 500) {
        Toast.error(i18next.t('message:errors.network:500'));
      } else {
        Toast.error(i18next.t('message:errors.network.common'));
      }
    },
    onUnexpectedError: () => Toast.error(i18next.t('message:errors.unexpected')),
  });
};

type AvailableApolloClientKeys = keyof typeof SERVICES_URL;

export const APOLLO_CLIENTS = Object.keys(SERVICES_URL).reduce(
  (accumulator, serviceKey: AvailableApolloClientKeys) => ({
    ...accumulator,
    [serviceKey]: generateClient(SERVICES_URL[serviceKey], false),
  }),
  {} as Record<AvailableApolloClientKeys, KargoApolloClient>,
);

export default {};
